import { z } from "zod";


export const ContratoFinanceiroSchema = z.object({
    idContratoFinanceiro: z.number().optional().nullable(),
    idCliente: z.number().optional().nullable(),
    idCentroCusto: z.number().optional().nullable(),
    idClienteCentroCusto: z.number().optional().nullable(), // unidade
    idIndiceReajuste: z.number().optional().nullable(),
    idFornecedor: z.number().optional().nullable(), // Comissão Corretor

    descricao: z.string().optional().nullable(),
    dataInicio: z.coerce.date({ invalid_type_error: "Data de início inválida." }).nullable().default(null),
    dataTermino: z.coerce.date({ invalid_type_error: "Data de término inválida." }).nullable().default(null),
    dataCadastro: z.coerce.date({ invalid_type_error: "Data de cadastro inválida." }).nullable().default(null),
    dataInicialReajuste: z.coerce.date({ invalid_type_error: "Data de inicio reajuste inválida." }).nullable().default(null),

    valorTotal: z.coerce.number().optional().nullable(),  // Financiado com a construtora
    valorVenda: z.coerce.number().optional().nullable(),
    valorGlobal: z.coerce.number().optional().nullable(),
    valorFinanciadoBanco: z.coerce.number().optional().nullable(),
    valorSaldoDevedor: z.coerce.number().optional().nullable(),
    percentualJuros: z.coerce.number().optional().nullable(),
    motivo: z.string().optional().nullable(),
    valorComissao: z.coerce.number().optional().nullable(),

    status: z.coerce.number()
        .refine((val) => [0, 1, 2, 3].includes(val), {
            message: "Status inválido.",
        })
        .default(0),
});

export type ContratoFinanceiroForm = z.infer<typeof ContratoFinanceiroSchema>;

export const defaultContratoFinanceiroForm: Partial<ContratoFinanceiroForm> = {
    status: 3,
    percentualJuros: 0

}